import React from 'react';
import { Star } from 'lucide-react';
export function StatsBar() {
  return <div className="bg-primary-dark border-y border-primary/30 py-6 pt-[20px] pb-[20px]" data-id="element-238">
      <div className="max-w-6xl mx-auto px-4" data-id="element-239">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-primary/30" data-id="element-240">
          <div className="flex flex-col items-center justify-center" data-id="element-241">
            <span className="text-3xl font-bold text-cream mb-1" data-id="element-242">+2.000</span>
            <span className="text-sm text-cream/80 uppercase tracking-wider" data-id="element-243">
              familias confían
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-244">
            <span className="text-3xl font-bold text-cream mb-1" data-id="element-245">6</span>
            <span className="text-sm text-cream/80 uppercase tracking-wider" data-id="element-246">
              Tomos listos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-247">
            <span className="text-3xl font-bold text-cream mb-1" data-id="element-248">6</span>
            <span className="text-sm text-cream/80 uppercase tracking-wider" data-id="element-249">
              Bonos incluidos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-250">
            <div className="flex items-center justify-center mb-1" data-id="element-251">
              <span className="text-3xl font-bold text-cream mr-2" data-id="element-252">4.9/5</span>
              <div className="flex" data-id="element-253">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-254" />)}
              </div>
            </div>
            <span className="text-sm text-cream/80 uppercase tracking-wider" data-id="element-255">
              calificación
            </span>
          </div>
        </div>
      </div>
    </div>;
}